import React, { useEffect, useState } from 'react';
import { Client } from "@twilio/conversations";
import apiUrl from 'slices/apiEndpoint';
import { getDecodeId } from 'slices/userProfile/thunk';
import ChatSidebar from './ChatSidebar';
import ChatWindow from './ChatWindow';

const Messages = () => {
  const userId = getDecodeId();
  const identity = `user_${userId}`;
  const [token, setToken] = useState("");
  const [conversations, setConversations] = useState<any[]>([]);
  const [loading, setLoadingState] = useState(true);
  const [selectedConversation, setSelectedConversation] = useState<any>(null);

  useEffect(() => {
    const fetchToken = async () => {
      setLoadingState(true);
      try {
        const res = await fetch(`${apiUrl}/chat/generate-token`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ identity }),
        });
        const data = await res.json();
        setToken(data.token);
      } catch (error) {
        console.error("❌ Error fetching token:", error);
      }
    };
    fetchToken();
  }, []);

  useEffect(() => {
    if (token) {
      const getConversations = async () => {
        const client = new Client(token);
        try {
          const conversationsPaginator = await client.getSubscribedConversations();
          setConversations(conversationsPaginator.items);
        } catch (error) {
          console.error("❌ Error fetching conversations:", error);
        } finally {
          setLoadingState(false);
        }
      };
      getConversations();
    }
  }, [token]);
  const handleDeleteConversation = (sid: string) => {
    setConversations(conversations.filter(c => c.sid !== sid));
    setSelectedConversation(null);
  };
  return (
    <div className="page-content tailwind-prefix bg-white flex flex-col">
      <div className="border-b mb-2 p-3">
        <input
          placeholder="All Messages"
          type="text"
          className="py-4 px-10 min-w-[400px] rounded-md outline-none bg-[#F6F7F9] border-none placeholder:text-black placeholder:font-semibold placeholder:text-[18px]"
          value=""
          readOnly
        />
      </div>
      <div className="flex h-[80vh] p-3 bg-[#FBFBFB]">
        <ChatSidebar
        selectedConversation={selectedConversation}
          conversations={conversations}
          loading={loading}
          selectConversation={setSelectedConversation}
        />
        <ChatWindow identity={identity} onDeleteConversation={handleDeleteConversation} selectedConversation={selectedConversation} />
      </div>
    </div>
  );
};

export default Messages;
